var map = {
	"./Switch.svg": 291,
	"./alert-icons/alert-icon-1.svg": 623,
	"./alert-icons/alert-icon-10.svg": 170,
	"./alert-icons/alert-icon-11.svg": 624,
	"./alert-icons/alert-icon-12.svg": 171,
	"./alert-icons/alert-icon-2.svg": 625,
	"./alert-icons/alert-icon-3.svg": 626,
	"./alert-icons/alert-icon-4.svg": 627,
	"./alert-icons/alert-icon-5.svg": 628,
	"./alert-icons/alert-icon-6.svg": 629,
	"./alert-icons/alert-icon-7.svg": 630,
	"./alert-icons/alert-icon-8.svg": 631,
	"./alert-icons/alert-icon-9.svg": 632,
	"./autofact-logo-white.svg": 633,
	"./autofact-logo.svg": 88,
	"./cameraRecord.svg": 292,
	"./card-identity-type-new.png": 172,
	"./card-identity-type-old.png": 173,
	"./check-v2.svg": 634,
	"./check.svg": 61,
	"./checklist.svg": 69,
	"./ci-antigua-ejemplo-back.png": 293,
	"./ci-antigua-ejemplo-front.png": 294,
	"./ci-back-ejemplo.jpg": 295,
	"./ci-back-new.svg": 635,
	"./ci-back.svg": 636,
	"./ci-ejemplo.jpg": 296,
	"./ci-front.svg": 637,
	"./claveunica.svg": 174,
	"./close.svg": 638,
	"./document-new.svg": 639,
	"./download-new.svg": 640,
	"./face-verification.svg": 175,
	"./face.svg": 641,
	"./fingerprint.svg": 176,
	"./front-card.svg": 177,
	"./ic-alert-modal.svg": 89,
	"./ic-back.svg": 642,
	"./ic-background.png": 643,
	"./ic-background.svg": 644,
	"./ic-camera-modal.svg": 178,
	"./ic-error-modal.svg": 90,
	"./ic-front.svg": 645,
	"./ic-instruction-01.svg": 646,
	"./ic-instruction-02.svg": 647,
	"./ic-instruction-03.svg": 648,
	"./ic-instruction-04.svg": 649,
	"./ic-instruction-05.png": 650,
	"./ic-instruction-05.svg": 651,
	"./ic-instruction-06.svg": 652,
	"./ic-instruction-07.svg": 653,
	"./ic-instruction-08.svg": 654,
	"./ic-instruction-09.svg": 655,
	"./ic-instruction-10.svg": 656,
	"./ic-instruction-11.svg": 657,
	"./ic-instruction-12.svg": 658,
	"./ic-instruction-13.svg": 659,
	"./ic-instruction-14.svg": 660,
	"./ic-unique-key-description.svg": 179,
	"./information-cirlce-gray.svg": 113,
	"./loading.gif": 661,
	"./logo-ecert-azul.svg": 662,
	"./logo-ecert-color.svg": 663,
	"./logo.svg": 664,
	"./logo_ecert.svg": 665,
	"./mandate.svg": 666,
	"./new-ci-back-ejemplo-2.jpeg": 297,
	"./new-ci-back-ejemplo.jpg": 667,
	"./new-ci-front-ejemplo.jpg": 298,
	"./notary-declaration.svg": 180,
	"./ok-circle.svg": 181,
	"./phosphoricons-clock-clockwise.svg": 182,
	"./red-cross.svg": 668,
	"./redirect.svg": 669,
	"./signature-new.svg": 670,
	"./signature.svg": 183,
	"./times-circle-solid.svg": 91,
	"./turn-phone.svg": 671,
	"./turncamera.svg": 299,
	"./unique_key_description.svg": 59
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39;